// generated by genversion
export var version = '5.0.11';
//# sourceMappingURL=version.js.map